import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-malawi-personal-loan.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorMalawiPersonalLoan = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorMalawiPersonalLoan, _super);
    function CalculatorMalawiPersonalLoan(element) {
        return _super.call(this, element) || this;
    }
    CalculatorMalawiPersonalLoan.prototype.init = function () {
        this.varInsuranceRate = 0.55;
        this.varOriginationRate = 2.10;
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputLoanAmount = this.element.querySelector('input[name=loan_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        this.totalInterest = this.element.querySelector('.js-interest-total');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-malawi-personal-loan__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        if (this.inputLoanAmount.value) {
            this.inputLoanAmount.value = this.formatNumbers(this.inputLoanAmount.value.replace(/ /g, ''));
        }
        this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorMalawiPersonalLoan.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonCalculate) {
            this.buttonCalculate.addEventListener('click', function (e) {
                _this.calculate();
            });
        }
        this.inputLoanAmount.addEventListener('keyup', function (event) {
            var element = event.target;
            // remove spaces
            var rawValue = element.value.replace(/ /g, '');
            // add thousand separators
            element.value = _this.formatNumbers(rawValue);
        });
    };
    CalculatorMalawiPersonalLoan.prototype.calculate = function () {
        var amortArray = [];
        var loanAmount = parseFloat(this.inputLoanAmount.value.replace(/ /g, '')) || 0;
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
        var month = parseFloat(this.inputTerm.value);
        var totalEstimation = 0;
        var totalInterest = 0;
        var totalInsurance = 0;
        for (var index = 0; index < term; index++) {
            var pmtNew = -this.PMT(interestRate / (term * 100), month, loanAmount, 0, 0);
            var insuranceRateValue = (loanAmount / 100) * this.varInsuranceRate;
            var calcMonthInterest = loanAmount * (interestRate / 100) / term;
            var calcMonthPrincipal = pmtNew - calcMonthInterest;
            totalInsurance += insuranceRateValue;
            totalInterest += calcMonthInterest;
            totalEstimation += pmtNew + insuranceRateValue;
            var lineItem = {
                month: month,
                principal: calcMonthPrincipal,
                interest: calcMonthInterest,
                insurancerate: insuranceRateValue,
                totalPayment: loanAmount - calcMonthPrincipal,
                pmt: pmtNew + insuranceRateValue,
                balance: loanAmount - calcMonthPrincipal,
                totalAccumulated: totalEstimation
            };
            loanAmount = loanAmount - calcMonthPrincipal;
            month -= 1;
            amortArray.push(lineItem);
        }
        console.log(amortArray);
        this.totalMonthly.innerHTML = this.roundFormatter(totalEstimation / term, 2, true);
        this.totalInterest.innerHTML = this.roundFormatter(totalInterest, 2, true);
    };
    CalculatorMalawiPersonalLoan.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    CalculatorMalawiPersonalLoan.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorMalawiPersonalLoan.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorMalawiPersonalLoan.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorMalawiPersonalLoan;
}(Base));
export { CalculatorMalawiPersonalLoan };



//////////////////
// WEBPACK FOOTER
// ./components-malawi/calculator-malawi-personal-loan/calculator-malawi-personal-loan.component.ts
// module id = 735
// module chunks = 0